import { useContext, useEffect } from "react";
import Scrollbar from "src/components/Scrollbar";
import { SidebarContext } from "src/contexts/SidebarContext";

import {
  Box,
  Drawer,
  alpha,
  styled,
  Divider,
  useTheme,
  Button,
  lighten,
  darken,
} from "@mui/material";

import SidebarMenu from "./SidebarMenu";
import Logo from "src/components/LogoWhite";

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme?.user?.sidebar.width};
        min-width: ${theme?.user?.sidebar.width};
        color: ${theme.colors.alpha.trueWhite[70]};
        position: relative;
        z-index: 7;
        height: 100%;
        padding-bottom: 68px;
`
);

function Sidebar() {
  const { sidebarToggle, openSidebar, closeSidebar } =
    useContext(SidebarContext);
  const theme = useTheme();
  // const width = document?.body?.clientWidth;

  // useEffect(() => {
  //   if (width > 991) {
  //     openSidebar();
  //   } else {
  //     closeSidebar();
  //   }
  // }, [width]);
  return (
    <>
      <SidebarWrapper
        sx={{
          display: "none",
          position: "fixed",
          left: 0,
          top: 0,
          background:
            theme.palette.mode === "dark"
              ? alpha(lighten(theme?.user?.header.background, 0.1), 0.5)
              : darken(theme.colors.alpha.secondary[100], 0.5),
          boxShadow:
            theme.palette.mode === "dark"
              ? theme?.user?.sidebar.boxShadow
              : "none",
        }}
      >
        <Scrollbar>
          <Box mt={3}>
            <Box
              mx={"auto"}
              sx={{
                width: "50%",
              }}
            >
              <Logo />
            </Box>
          </Box>
          <Divider
            sx={{
              mt: theme.spacing(3),
              mx: theme.spacing(2),
              background: theme.colors.alpha.trueWhite[10],
            }}
          />
          <SidebarMenu />
        </Scrollbar>
        <Divider
          sx={{
            background: theme.colors.alpha.trueWhite[10],
          }}
        />
        <Box p={2}>
          <Button
            href="#"
            onClick={() => alert("logout")}
            rel="noopener noreferrer"
            variant="contained"
            color="warning"
            size="small"
            fullWidth
          >
            Logout
          </Button>
        </Box>
      </SidebarWrapper>
      <Drawer
        sx={{
          boxShadow: `${theme?.user?.sidebar.boxShadow}`,
        }}
        anchor={theme.direction === "rtl" ? "right" : "left"}
        open={sidebarToggle}
        onClose={closeSidebar}
        variant="temporary"
        elevation={9}
      >
        <SidebarWrapper
          sx={{
            background:
              theme.palette.mode === "dark"
                ? theme.colors.alpha.white[100]
                : darken(theme.colors.alpha.secondary[100], 0.5),
          }}
        >
          <Scrollbar>
            <Box mt={3}>
              <Box
                mx={"auto"}
                sx={{
                  width: "50%",
                }}
              >
                <Logo />
              </Box>
            </Box>
            <Divider
              sx={{
                mt: theme.spacing(3),
                mx: theme.spacing(2),
                background: theme.colors.alpha.trueWhite[10],
              }}
            />
            <SidebarMenu />
          </Scrollbar>
        </SidebarWrapper>
      </Drawer>
    </>
  );
}

export default Sidebar;
